import { useState } from "react";
import { Layout } from "@/components/layout";
import { ContractorsTable } from "@/components/internal-contractors/ContractorsTable";
import { OnboardingForm } from "@/components/internal-contractors/OnboardingForm";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { UserPlus, RefreshCw } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";

export default function ContractorsPage() {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const queryClient = useQueryClient();

  const handleRefreshAll = () => {
    queryClient.invalidateQueries({ queryKey: ["/api/internal/contractors"] });
  };

  return (
    <Layout headerContent={
      <div className="flex items-center gap-2 text-sm">
        <span className="text-muted-foreground">Internal</span>
        <span className="text-muted-foreground">/</span>
        <span className="font-semibold">Contractors</span>
      </div>
    }>
      <div className="container mx-auto py-6 space-y-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold">Contractors</h1>
            <p className="text-muted-foreground mt-1">
              Manage contractor organizations, metadata, and product pricing
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handleRefreshAll}>
              <RefreshCw className="h-4 w-4 mr-2" />
              Refresh
            </Button>
            <Dialog open={addDialogOpen} onOpenChange={setAddDialogOpen}>
              <DialogTrigger asChild>
                <Button>
                  <UserPlus className="h-4 w-4 mr-2" />
                  Add Contractor
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Add New Contractor</DialogTitle>
                  <DialogDescription>
                    Create a new contractor organization in Clerk and Supabase
                  </DialogDescription>
                </DialogHeader>
                <OnboardingForm
                  onSuccess={() => {
                    setAddDialogOpen(false);
                    queryClient.invalidateQueries({
                      queryKey: ["/api/internal/contractors"],
                    });
                  }}
                />
              </DialogContent>
            </Dialog>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Contractors</CardTitle>
            <CardDescription>
              View and manage all contractor organizations. Click a row to expand for more details.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ContractorsTable />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
